export default (() => {

    function containsKeys (object, array) {
        if (object === undefined || array === undefined) {            
            return wealthify.error.throwError('type.object.containsKeys', 'object and array must be defined');
        }

        if (!isObject(object)) {
            return wealthify.error.throwError('type.object.containsKeys', 'object must be of type object');
        }

        if (typeof array === 'string') {
            return Object.prototype.hasOwnProperty.call(object, array);
        }

        return array.every((key) => Object.keys(object).includes(key.toString()));
    }

    function deepCopy (inObject) {
        let outObject, value, key;
      
        if (typeof inObject !== 'object' || inObject === null) {
            return inObject;
        }
      
        outObject = Array.isArray(inObject) ? [] : {};
      
        for (key in inObject) {
            value = inObject[key];
      
            outObject[key] = deepCopy(value);
        }
      
        return outObject;
    }

    function isObject (value) {        
        return typeof value === 'object' && value !== null;
    }

    function toObject (value) {
        if (value === undefined) {            
            return wealthify.error.throwError('type.array.toObject', 'value must be defined');
        }

        if (isObject(value)) {
            return value;
        }

        if (typeof value !== 'string') {
            return wealthify.error.throwError('type.array.toObject', 'value must be of type string');
        }

        return wealthify.convert.toJson(value);
    }

    function isShallowEqualToOtherObject (object1, object2) {
        return JSON.stringify(object1) === JSON.stringify(object2);
    }

    return {
        containsKeys,
        deepCopy,
        isObject,
        toObject,
        isShallowEqualToOtherObject
    };

})();